import React, { useMemo } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {
  REVEAL_INITIAL,
  REVEAL_ANIMATE,
  REVEAL_TRANSITION_BASE,
} from "@/lib/motion";

const INVIEW_OPTIONS = { threshold: 0.12, triggerOnce: true };

export function Reveal({ children, delay = 0, y = 16, className = "" }) {
  const { ref, inView } = useInView(INVIEW_OPTIONS);
  // Memoize per-instance values so we don't recreate objects each render.
  const initial = useMemo(() => ({ ...REVEAL_INITIAL, y }), [y]);
  const animate = useMemo(
    () => (inView ? REVEAL_ANIMATE : initial),
    [inView, initial],
  );
  const transition = useMemo(
    () => ({ ...REVEAL_TRANSITION_BASE, delay }),
    [delay],
  );
  return (
    <motion.div
      ref={ref}
      initial={initial}
      animate={animate}
      transition={transition}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Section({ id, children, className = "", testid }) {
  return (
    <section
      id={id}
      data-testid={testid}
      className={`relative w-full py-20 md:py-28 lg:py-32 ${className}`}
    >
      {children}
    </section>
  );
}

export function Container({ children, className = "" }) {
  return (
    <div className={`mx-auto max-w-7xl px-6 md:px-10 lg:px-14 ${className}`}>
      {children}
    </div>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <div className={`label-eyebrow flex items-center gap-3 ${className}`}>
      <span className="inline-block h-px w-8 bg-arven-gold" />
      <span>{children}</span>
    </div>
  );
}
